import { createSimpleThemedComponent } from '../util/createThemedComponent';
export var Heading = createSimpleThemedComponent(function (_a) {
    var as = _a.as;
    return ({
        variant: as || 'h1',
        as: 'h1',
    });
});
//# sourceMappingURL=Heading.js.map